import { createContext } from '@lit/context';
import { SORT } from '../util/filter-sort';

export const sortContext = createContext<SORT>(Symbol('sort'));
